import * as filters from './filters/reducer'
import * as list from './list/reducer'
import * as report from './report/reducer'
import * as schedule from './schedule/reducer'
import * as summary from './summary/reducer'


export default {
  filters,
  summary,
  list,
  schedule,
  report,
}
